import { gasApi } from '@/api/gas'

/** 从站点管理接口加载下拉选项，选项接口异常时回退到站点列表 */
export async function fetchSiteOptions() {
  try {
    const res = await gasApi.site.options()
    const list = (res.data || [])
      .map(s => (typeof s === 'string' ? s : (s && (s.siteName || s.name)) || ''))
      .filter(Boolean)
    if (list.length) return list
  } catch (e) {}
  try {
    const res = await gasApi.site.list({ pageNum: 1, pageSize: 500 })
    const records = (res.data && res.data.records) || []
    return records.map(r => r && r.siteName).filter(Boolean)
  } catch (e) {
    return []
  }
}

export default {
  data() {
    return {
      siteOptions: []
    }
  },
  methods: {
    async loadSiteOptions() {
      this.siteOptions = await fetchSiteOptions()
    },
    ensureSiteOption(name) {
      const n = (name || '').trim()
      if (!n) return
      if (!(this.siteOptions || []).includes(n)) {
        this.siteOptions = [...(this.siteOptions || []), n]
      }
    }
  }
}
